import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import "./Datatable.styles.css";
import messageIcon from '../../assets/images/staricon.svg';
import { Project } from '../../utils/types'; 
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import Loader from '../Loader/loader.components';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip'

interface Column {
  key: keyof Project;
  label: string;
}

interface DataTableProps {
  initialData: Project[];
  columns: Column[];
  context: 'grid' | 'list';
  isLoadingTable: boolean;
}

const DataTable: React.FC<DataTableProps> = ({ initialData, columns, context, isLoadingTable }) => {
  const navigate = useNavigate();
  const [data, setData] = useState<Project[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc');

  const handleExport = async () => {
    const pdf = new jsPDF();
    const element = document.querySelector('.cardetailsmodel') as HTMLElement;
    if (element) {
      const canvas = await html2canvas(element);
      const imgData = canvas.toDataURL('image/png');
      pdf.addImage(imgData, 'PNG', 10, 10, 190, 0); 
      pdf.save('data_export.pdf'); 
    }
  };

  useEffect(() => {
    setData(initialData);
  }, [initialData]);

  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  const sortData = (key: keyof Project) => {
    const sortedData = [...data].sort((a, b) => {
      let aValue: string | number = a[key];
      let bValue: string | number = b[key];
  
      if (key === 'reportDueDate') {
        aValue = new Date(aValue as string).getTime();
        bValue = new Date(bValue as string).getTime();
      }
  
      if (aValue < bValue) return sortDirection === 'asc' ? -1 : 1;
      if (aValue > bValue) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });
    setData(sortedData);
    setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
  };

  const handleRowClick = (ProjectId: string) => {
    navigate('/project', { state: { ProjectId } });
  };

  const renderSortIcon = () => {
    return (
      <span style={{ cursor: 'pointer' }}>
        {sortDirection === 'asc' ? (
          <i className="bi bi-arrow-up" style={{ fontSize: '0.8em' }}></i>
        ) : (
          <i className="bi bi-arrow-down" style={{ fontSize: '0.8em' }}></i>
        )}
      </span>
    );
  };

  if (error) {
    return <div className="alert alert-danger">{error}</div>;
  }



  return (
    
    <div className='main-container'>
      {!isLoadingTable ? "" : <Loader/>}

      <div className="">
      {data.length === 0 ? (
  <div className="no-results-message">No results found for the search keyword.</div>
) :context === 'list' ? (
        
        <table className="allfindingstable table">
          <thead className="thead-light">
            <tr>
              {columns.map(col => (
                <th key={col.key} onClick={() => sortData(col.key)}>
                  {col.label} 
                  {col.key === 'reportDueDate' && renderSortIcon()} 
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
          {data.map((item: any, index) => (
            <tr
              key={index}
              onClick={() => handleRowClick(item.Id)}  
              className={'cars-row customtr'}
              style={{ cursor: 'pointer' }}
            >
              <td>{item.inspire1__Account__r.Name}</td> 
              <td>{item.inspire1__Opportunity1__r.Related_Certificate_Number__c || '--'}</td> 
              <td>{item.Name}</td>
              <td style={{ fontWeight: 800 }}>{item.inspire1__Project_Status__c || '--'}</td>
              <td>
                {item.inspire1__Inspire_Tasks__r?.records?.[0]?.inspire1__Finish_Date_Only__c 
                  ? formatDate(item.inspire1__Inspire_Tasks__r.records[0].inspire1__Finish_Date_Only__c) 
                  : '--'}
              </td>
            </tr>
          ))}
        </tbody>
        </table>
      ) : (
        <div className="grid-container">
          {data.map((item:any, index) => (
            <div key={index} className="grid-item" onClick={() => handleRowClick(item.Id)}>
              <div className="grid-row">
                <div className="grid-col">
                  <p style={{color:"#78A22F"}} className='m-0'><strong>{item.inspire1__Account__r.Name}</strong></p>
                </div>
                <div className="grid-col">
                  <p>{item.inspire1__Opportunity1__r.Related_Certificate_Number__c || '--'}</p>
                </div>
                <div className="grid-col">
                <OverlayTrigger overlay={<Tooltip bsPrefix="auditor-project-tooltip" className="auditor-project-tooltip" id={item.Name}><b>Project Name:&nbsp;</b>{item.Name}</Tooltip>}>
                  <p className="auditor-grid-project-name">{item.Name}</p>
                </OverlayTrigger>
                </div>
                <div className="grid-col" style={{ fontWeight: 800 }}>
                  <p>{item.inspire1__Project_Status__c || '--'}</p>
                </div>
                <div className="grid-col">
                  <p>{ item.inspire1__Inspire_Tasks__r?.records?.[0]?.inspire1__Finish_Date_Only__c ? formatDate(item.inspire1__Inspire_Tasks__r?.records?.[0]?.inspire1__Finish_Date_Only__c ) : "--"}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      </div>
    </div>
  );
};

export default DataTable;
